import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withKeys as _withKeys, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "p-field p-mt-1 p-col-6" }
const _hoisted_3 = { class: "p-float-label" }
const _hoisted_4 = {
  for: "label",
  class: "kn-material-input-label"
}
const _hoisted_5 = { class: "p-field p-mt-1 p-col-6" }
const _hoisted_6 = { class: "p-float-label" }
const _hoisted_7 = {
  for: "name",
  class: "kn-material-input-label"
}
const _hoisted_8 = { class: "p-field p-mt-1 p-col-12" }
const _hoisted_9 = { class: "p-float-label" }
const _hoisted_10 = {
  for: "description",
  class: "kn-material-input-label"
}
const _hoisted_11 = { class: "p-field p-mt-1 p-col-6" }
const _hoisted_12 = { class: "p-float-label" }
const _hoisted_13 = {
  for: "scope",
  class: "kn-material-input-label"
}
const _hoisted_14 = { class: "p-field p-mt-1 p-col-6" }
const _hoisted_15 = { class: "p-float-label" }
const _hoisted_16 = {
  key: 0,
  for: "category",
  class: "kn-material-input-label"
}
const _hoisted_17 = {
  key: 1,
  for: "category",
  class: "kn-material-input-label"
}
const _hoisted_18 = { class: "p-field p-mt-1 p-col-12" }
const _hoisted_19 = { class: "p-float-label kn-material-input" }
const _hoisted_20 = {
  for: "tags",
  class: "kn-material-input-label"
}
const _hoisted_21 = { id: "username1-help" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_KnValidationMessages = _resolveComponent("KnValidationMessages")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_AutoComplete = _resolveComponent("AutoComplete")
  const _component_Card = _resolveComponent("Card")
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Card, { class: "p-m-2" }, {
      content: _withCtx(() => [
        _createVNode("form", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("span", _hoisted_3, [
              _createVNode(_component_InputText, {
                id: "label",
                class: ["kn-material-input", { 'p-invalid': _ctx.v$.dataset.label.$invalid && _ctx.v$.dataset.label.$dirty }],
                type: "text",
                maxLength: "50",
                modelValue: _ctx.v$.dataset.label.$model,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.v$.dataset.label.$model = $event)),
                onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.dataset.label.$touch())),
                onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('touched'))),
                "data-test": "label-input"
              }, null, 8, ["modelValue", "class"]),
              _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('common.label')) + " * ", 1)
            ]),
            _createVNode(_component_KnValidationMessages, {
              class: "p-mt-1",
              vComp: _ctx.v$.dataset.label,
              additionalTranslateParams: { fieldName: _ctx.$t('common.label') }
            }, null, 8, ["vComp", "additionalTranslateParams"])
          ]),
          _createVNode("div", _hoisted_5, [
            _createVNode("span", _hoisted_6, [
              _createVNode(_component_InputText, {
                id: "name",
                class: ["kn-material-input", { 'p-invalid': _ctx.v$.dataset.name.$invalid && _ctx.v$.dataset.name.$dirty }],
                type: "text",
                maxLength: "50",
                modelValue: _ctx.v$.dataset.name.$model,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.v$.dataset.name.$model = $event)),
                onBlur: _cache[5] || (_cache[5] = ($event: any) => (_ctx.v$.dataset.name.$touch())),
                onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('touched'))),
                "data-test": "name-input"
              }, null, 8, ["modelValue", "class"]),
              _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('common.name')) + " * ", 1)
            ]),
            _createVNode(_component_KnValidationMessages, {
              class: "p-mt-1",
              vComp: _ctx.v$.dataset.name,
              additionalTranslateParams: { fieldName: _ctx.$t('common.name') }
            }, null, 8, ["vComp", "additionalTranslateParams"])
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode("span", _hoisted_9, [
              _createVNode(_component_InputText, {
                id: "description",
                class: ["kn-material-input", { 'p-invalid': _ctx.v$.dataset.description.$invalid && _ctx.v$.dataset.description.$dirty }],
                type: "text",
                maxLength: "150",
                modelValue: _ctx.v$.dataset.description.$model,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.v$.dataset.description.$model = $event)),
                onBlur: _cache[8] || (_cache[8] = ($event: any) => (_ctx.v$.dataset.description.$touch())),
                onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('touched'))),
                "data-test": "description-input"
              }, null, 8, ["modelValue", "class"]),
              _createVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('common.description')), 1)
            ]),
            _createVNode(_component_KnValidationMessages, {
              class: "p-mt-1",
              vComp: _ctx.v$.dataset.description,
              additionalTranslateParams: { fieldName: _ctx.$t('common.description') }
            }, null, 8, ["vComp", "additionalTranslateParams"])
          ]),
          _createVNode("div", _hoisted_11, [
            _createVNode("span", _hoisted_12, [
              _createVNode(_component_Dropdown, {
                id: "scope",
                class: ["kn-material-input", {
                                'p-invalid': _ctx.v$.dataset.scopeId.$invalid && _ctx.v$.dataset.scopeId.$dirty
                            }],
                options: _ctx.scopeTypes,
                optionLabel: "VALUE_CD",
                optionValue: "VALUE_ID",
                modelValue: _ctx.v$.dataset.scopeId.$model,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.v$.dataset.scopeId.$model = $event)),
                onBeforeShow: _cache[11] || (_cache[11] = ($event: any) => (_ctx.v$.dataset.scopeId.$touch())),
                onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.updateCdFromId(this.scopeTypes, 'scopeCd', $event.value), _ctx.$emit('touched'))),
                "data-test": "scope-input"
              }, null, 8, ["options", "modelValue", "class"]),
              _createVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('managers.datasetManagement.scope')) + " * ", 1)
            ]),
            _createVNode(_component_KnValidationMessages, {
              vComp: _ctx.v$.dataset.scopeId,
              additionalTranslateParams: {
                            fieldName: _ctx.$t('managers.datasetManagement.scope')
                        }
            }, null, 8, ["vComp", "additionalTranslateParams"])
          ]),
          _createVNode("div", _hoisted_14, [
            _createVNode("span", _hoisted_15, [
              _createVNode(_component_Dropdown, {
                id: "category",
                class: ["kn-material-input", {
                                'p-invalid': _ctx.v$.dataset.catTypeId.$invalid && _ctx.v$.dataset.catTypeId.$dirty
                            }],
                options: _ctx.categoryTypes,
                optionLabel: "VALUE_CD",
                optionValue: "VALUE_ID",
                modelValue: _ctx.v$.dataset.catTypeId.$model,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.v$.dataset.catTypeId.$model = $event)),
                showClear: _ctx.dataset.scopeCd === 'USER',
                onBeforeShow: _cache[14] || (_cache[14] = ($event: any) => (_ctx.v$.dataset.catTypeId.$touch())),
                onChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.updateCdFromId(this.categoryTypes, 'catTypeVn', $event.value), _ctx.$emit('touched'))),
                "data-test": "category-input"
              }, null, 8, ["options", "modelValue", "class", "showClear"]),
              (this.dataset.scopeCd == 'USER')
                ? (_openBlock(), _createBlock("label", _hoisted_16, _toDisplayString(_ctx.$t('common.category')), 1))
                : (_openBlock(), _createBlock("label", _hoisted_17, _toDisplayString(_ctx.$t('common.category')) + " * ", 1))
            ]),
            _createVNode(_component_KnValidationMessages, {
              vComp: _ctx.v$.dataset.catTypeId,
              additionalTranslateParams: {
                            fieldName: _ctx.$t('managers.datasetManagement.scope')
                        }
            }, null, 8, ["vComp", "additionalTranslateParams"])
          ]),
          _createVNode("div", _hoisted_18, [
            _createVNode("span", _hoisted_19, [
              _createVNode(_component_AutoComplete, {
                modelValue: _ctx.dataset.tags,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.dataset.tags = $event)),
                suggestions: _ctx.filteredTagsNames,
                multiple: true,
                onComplete: _ctx.searchTag,
                onKeydown: _withKeys(_ctx.createTagChip, ["enter"])
              }, {
                chip: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.value.name), 1)
                ]),
                item: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.item.name), 1)
                ]),
                _: 1
              }, 8, ["modelValue", "suggestions", "onComplete", "onKeydown"]),
              _createVNode("label", _hoisted_20, _toDisplayString(_ctx.$t('common.tags')), 1)
            ]),
            _createVNode("small", _hoisted_21, _toDisplayString(_ctx.$t('managers.widgetGallery.tags.availableCharacters')), 1)
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_Card, { class: "p-m-2" }, {
      header: _withCtx(() => [
        _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
          start: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('managers.datasetManagement.oldVersions')), 1)
          ]),
          end: _withCtx(() => [
            _createVNode(_component_Button, {
              icon: "fas fa-eraser",
              class: "p-button-text p-button-rounded p-button-plain",
              disabled: _ctx.noDatasetVersions,
              onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.deleteConfirm('deleteAll')))
            }, null, 8, ["disabled"])
          ]),
          _: 1
        })
      ]),
      content: _withCtx(() => [
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_ProgressBar, {
              key: 0,
              mode: "indeterminate",
              class: "kn-progress-bar",
              "data-test": "versions-loading"
            }))
          : _createCommentVNode("", true),
        (!_ctx.loading)
          ? (_openBlock(), _createBlock(_component_DataTable, {
              key: 1,
              class: "p-datatable-sm kn-table",
              value: _ctx.selectedDatasetVersions,
              scrollable: true,
              scrollHeight: "400px",
              loading: _ctx.loading,
              dataKey: "versNum",
              responsiveLayout: "stack",
              breakpoint: "960px"
            }, {
              empty: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('managers.datasetManagement.noVersions')), 1)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_Column, {
                  field: "userIn",
                  header: _ctx.$t('managers.datasetManagement.creationUser'),
                  sortable: true
                }, null, 8, ["header"]),
                _createVNode(_component_Column, {
                  field: "type",
                  header: _ctx.$t('importExport.gallery.column.type'),
                  sortable: true
                }, null, 8, ["header"]),
                _createVNode(_component_Column, {
                  field: "dateIn",
                  header: _ctx.$t('managers.mondrianSchemasManagement.headers.creationDate'),
                  dataType: "date",
                  sortable: true
                }, {
                  body: _withCtx(({data}) => [
                    _createTextVNode(_toDisplayString(_ctx.formatDate(data.dateIn)), 1)
                  ]),
                  _: 1
                }, 8, ["header"]),
                _createVNode(_component_Column, { onRowClick: false }, {
                  body: _withCtx((slotProps) => [
                    (slotProps.data.versNum !== 0)
                      ? (_openBlock(), _createBlock(_component_Button, {
                          key: 0,
                          icon: "fas fa-retweet",
                          class: "p-button-link",
                          onClick: ($event: any) => (_ctx.restoreVersionConfirm(slotProps.data))
                        }, null, 8, ["onClick"]))
                      : _createCommentVNode("", true),
                    (slotProps.data.versNum !== 0)
                      ? (_openBlock(), _createBlock(_component_Button, {
                          key: 1,
                          icon: "pi pi-trash",
                          class: "p-button-link",
                          onClick: ($event: any) => (_ctx.deleteConfirm('deleteOne', slotProps.data))
                        }, null, 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value", "loading"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}